var styles = {
  "SkeletonTitle": "Polaris-SkeletonPage__SkeletonTitle"
};

export { styles as default };
